export interface MonitoramentoConciliacaoRequest {
  id?: number;
  anoReferencia: number;
  mesReferencia: number;
  quantidadeRequerimentos: number;
  quantidadeSessoes: number;
  valorTotalAcordos: number;
}

function parseInteiro(value: any): number | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  if (typeof value === 'number') {
    return value;
  }

  const digitos = value.toString().replace(/\D/g, '');
  return digitos === '' ? null : Number(digitos);
}

export function parseValorMonetario(value: any): number | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  if (typeof value === 'number') {
    return value;
  }

  // A máscara "separator.2" entrega o valor no model com ponto decimal (ex.: "1234.56");
  // valores no formato pt-BR (ex.: "1.234,56") também são aceitos.
  let normalizado = value.toString().replace(/[^\d,.-]/g, '');
  if (normalizado.indexOf(',') >= 0) {
    normalizado = normalizado.replace(/\./g, '').replace(',', '.');
  }

  if (normalizado === '') {
    return null;
  }

  const parsed = Number(normalizado);
  return isNaN(parsed) ? null : parsed;
}

export function mapMonitoramentoFormToRequest(raw: any): MonitoramentoConciliacaoRequest {
  return {
    id: raw.id,
    anoReferencia: parseInteiro(raw.anoReferencia),
    mesReferencia: parseInteiro(raw.mesReferencia),
    quantidadeRequerimentos: parseInteiro(raw.quantidadeRequerimentos),
    quantidadeSessoes: parseInteiro(raw.quantidadeSessoes),
    valorTotalAcordos: parseValorMonetario(raw.valorTotalAcordos)
  };
}
